import React from 'react'
import IMG1 from '../../assets/kodyani.png'
import IMG2 from '../../assets/spotify.png'
import IMG3 from '../../assets/zino-blogs.png'
import IMG4 from '../../assets/meeeteor.png'
import IMG5 from '../../assets/cafila.png'
import IMG6 from '../../assets/sofa.png'
import IMG7 from '../../assets/abqara.png'
import {
  BiLogoCss3,
  BiLogoFirebase,
  BiLogoGit,
  BiLogoGithub,
  BiLogoGoLang,
  BiLogoJavascript,
  BiLogoMongodb,
  BiLogoNodejs,
  BiLogoReact,
  BiLogoRedux,
  BiLogoSpotify,
  BiLogoTailwindCss,
  BiLogoVuejs,
} from 'react-icons/bi'
import { TbBrandNextjs } from 'react-icons/tb'
import { SiExpress, SiMariadb, SiSocketdotio, SiWebrtc } from 'react-icons/si'
import './portfolio.css'

const Portfolio = () => {
  const soloProjects = [
    {
      id: 1,
      title: 'Fruit Mart',
      img: IMG1,
      description:
        'Fruit Mart is your one-stop e-commerce destination, where customers enjoy a seamless shopping experience. After easy authentication, customers can browse and order a wide range of products, effortlessly filter by category, or swiftly find specific items.',
      // technologies: 'Next | React | Redux | Node | Express | Firebase',
      technologies: [
        <TbBrandNextjs color='#000000' size={30} title='Next.js' />,
        <BiLogoReact color='#61dbfb' size={30} title='React.js' />,
        <BiLogoRedux color='#764abc' size={30} title='Redux' />,
        <BiLogoNodejs color='#68a063' size={30} title='Node.js' />,
        <SiExpress color='#ffffff' size={30} title='Express' />,
        <BiLogoFirebase color='#ffca28' size={30} title='Firebase' />,
      ],
      link: 'https://www.fruitmart.ae/',
      github: 'https://github.com/ZineddineBk09/fruit-mart',
    },
    {
      id: 2,
      title: 'Meeteor',
      img: IMG4,
      description:
        'Meeeteor is a minimalistic yet powerful online meeting application. Create, host, and collaborate effortlessly in meetings while engaging with participants via a dynamic chat feature. Simplify your virtual interactions with Meeeteor.',
      // technologies:
      // 'Vanilla Javascript | EJS | Node | Express | Sockets | MongoDB',
      technologies: [
        <BiLogoJavascript color='#f7df1e' size={30} title='Javascript' />,
        <BiLogoNodejs color='#68a063' size={30} title='Node.js' />,
        <SiExpress color='#ffffff' size={30} title='Express' />,
        <BiLogoMongodb color='#4db33d' size={30} title='MongoDB' />,
        <SiSocketdotio color='#010101' size={30} title='Socket.io' />,
        <SiWebrtc color='#ffffff' size={30} title='WebRTC' />,
      ],
      link: '',
      github: 'https://github.com/ZineddineBk09/Meeeteor',
    },
    {
      id: 3,
      title: 'Spotify Clone Application',
      img: IMG2,
      description:
        'Your gateway to the world of music. Search, play, and curate your playlists with ease, thanks to seamless integration with the Spotify API. Discover your favorite tunes and let the music take center stage.',
      // technologies: 'Next | React | Spotify API | Firebase',
      technologies: [
        <TbBrandNextjs color='#000000' size={30} title='Next.js' />,
        <BiLogoReact color='#61dbfb' size={30} title='React.js' />,
        <BiLogoSpotify color='#1db954' size={30} title='Spotify API' />,
        <BiLogoFirebase color='#ffca28' size={30} title='Firebase' />,
      ],
      link: '',
      github: 'https://github.com/ZineddineBk09/Spotify',
    },
    {
      id: 4,
      title: 'FireBlogs',
      img: IMG3,
      description:
        'FireBlogs is your canvas for expression. Craft, edit, and publish your blogs effortlessly after a quick authentication process. Engage with a community of readers and writers through comments, making it a dynamic platform for sharing ideas.',
      // technologies: 'Vue | SCSS | Firebase',
      technologies: [
        <BiLogoVuejs color='#4fc08d' size={30} title='Vue.js' />,
        <BiLogoCss3 color='#264de4' size={30} title='SCSS' />,
        <BiLogoFirebase color='#ffca28' size={30} title='Firebase' />,
      ],
      link: 'https://fireblogs-50850.web.app/',
      github: 'https://github.com/Meri-MG/shelter',
    },
    {
      id: 5,
      title: 'Cafila',
      img: IMG5,
      description:
        "Cafila, a responsive web application I crafted at Abqara, a SaaS company specializing in transportation solutions, centers on my role in front-end development. It provides users with easy access to the company's services and facilitates seamless communication with them.",
      // technologies: 'Next | React | Redux | GO | MariaDB',
      technologies: [
        <TbBrandNextjs color='#000000' size={30} title='Next.js' />,
        <BiLogoReact color='#61dbfb' size={30} title='React.js' />,
        <BiLogoRedux color='#764abc' size={30} title='Redux' />,
        <BiLogoTailwindCss color='#06b6d4' size={30} title='TailwindCSS' />,
        <BiLogoGoLang color='#00add8' size={30} title='Go' />,
        <SiMariadb color='#003545' size={30} title='MariaDB' />,
      ],
      link: '',
      github: 'https://github.com/ZineddineBk09',
    },
    {
      id: 6,
      title: 'Sofa',
      img: IMG6,
      description:
        'Sofa, a responsive streaming platform I developed at Abqara, a SaaS company, is dedicated to delivering an immersive online movie and series-watching experience. My role primarily involved front-end development, allowing users to seamlessly search for and enjoy their favorite movies and series.',
      // technologies: 'Next | React | Redux | Node | Express | MongoDB',
      technologies: [
        <TbBrandNextjs color='#000000' size={30} title='Next.js' />,
        <BiLogoReact color='#61dbfb' size={30} title='React.js' />,
        <BiLogoRedux color='#764abc' size={30} title='Redux' />,
        <BiLogoTailwindCss color='#06b6d4' size={30} />,
        <BiLogoGoLang color='#00add8' size={30} title='Go' />,
        <SiMariadb color='#003545' size={30} title='MariaDB' />,
      ],
      link: '',
      github: 'https://github.com/ZineddineBk09',
    },
    {
      id: 7,
      title: 'Abqara',
      img: IMG7,
      description:
        'Abqara, a responsive web application I crafted for a forward-thinking SaaS company, connects you with innovative IT solutions.',
      // technologies: 'Next | React | Redux | Node | Express | MongoDB',
      technologies: [
        <TbBrandNextjs color='#000000' size={30} title='Next.js' />,
        <BiLogoReact color='#61dbfb' size={30} title='React.js' />,
        <BiLogoTailwindCss color='#06b6d4' size={30} title='TailwindCSS' />,
      ],
      link: 'https://abqara-web.vercel.app/',
      github: 'https://github.com/ZineddineBk09',
    },
  ]

  return (
    <section id='portfolio'>
      <h5>My Personal Projects</h5>
      <h2>Portfolio</h2>

      <div className='container portfolio__container'>
        {soloProjects.map((pro, index) => (
          <article className='portfolio__item w-full mx-auto' key={index}>
            <div className='portfolio__item-image'>
              <img src={pro.img} alt={pro.title} />
            </div>
            <div className='portfolio__item-content'>
              <h3>{pro.title}</h3>
              <p className='desc'>{pro.description}</p>
              <p className='techs'>
                <span>Techs:</span> {pro.technologies}
              </p>
            </div>
            <div className='portfolio__item-cta'>
              <a
                href={pro.github}
                target='_blank'
                className='btn'
                rel='noreferrer'
              >
                GitHub
              </a>
              {pro.link && (
                <a
                  href={pro.link}
                  target='_blank'
                  className='btn btn-primary'
                  rel='noreferrer'
                >
                  Live Demo
                </a>
              )}
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default Portfolio
